import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/mobile_main';

export default function MobileMain() {
  return (
    <>
      <PageTemplate type={true}>
        <Container />
      </PageTemplate>
    </>
  );
}
